import React, { createContext, useState, useContext, useEffect } from 'react';
import axios from 'axios';

const ProviderAuthContext = createContext(null);

const API = process.env.REACT_APP_BACKEND_URL;

export const ProviderAuthProvider = ({ children }) => {
  const [provider, setProvider] = useState(null);
  const [token, setToken] = useState(localStorage.getItem('providerToken'));
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (token) {
      fetchProvider();
    } else {
      setLoading(false);
    }
  }, [token]);

  const fetchProvider = async () => {
    try {
      const response = await axios.get(`${API}/api/provider/me`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setProvider(response.data);
    } catch (error) {
      console.error('Failed to fetch provider:', error);
      logout();
    } finally {
      setLoading(false);
    }
  };

  const login = async (tokenOrEmail, passwordOrProvider) => {
    // Support two modes: (token, providerData) from unified login, or (email, password) direct
    if (typeof passwordOrProvider === 'object' && passwordOrProvider !== null) {
      // Called from unified login with (token, providerData)
      localStorage.setItem('providerToken', tokenOrEmail);
      setToken(tokenOrEmail);
      setProvider(passwordOrProvider);
      return passwordOrProvider;
    }
    // Legacy: called with (email, password)
    const response = await axios.post(`${API}/api/provider/login`, {
      email: tokenOrEmail,
      password: passwordOrProvider
    }, { validateStatus: (s) => s === 200 });
    const { token: newToken, provider: providerData } = response.data;
    localStorage.setItem('providerToken', newToken);
    setToken(newToken);
    setProvider(providerData);
    return providerData;
  };

  const logout = () => {
    const currentToken = localStorage.getItem('providerToken');
    if (currentToken) {
      const API = process.env.REACT_APP_BACKEND_URL;
      fetch(`${API}/api/provider/logout`, { method: 'POST', headers: { Authorization: `Bearer ${currentToken}` } }).catch(() => {});
    }
    localStorage.removeItem('providerToken');
    setToken(null);
    setProvider(null);
  };

  return (
    <ProviderAuthContext.Provider value={{ provider, token, loading, login, logout, setProvider }}>
      {children}
    </ProviderAuthContext.Provider>
  );
};

export const useProviderAuth = () => {
  const context = useContext(ProviderAuthContext);
  if (!context) {
    throw new Error('useProviderAuth must be used within ProviderAuthProvider');
  }
  return context;
};
